import { createIcon } from '@chakra-ui/react';

export const Download = createIcon({
  displayName: 'Download',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M6 7.33334V11.3333L7.33333 10" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.99935 11.3333L4.66602 10" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6673 6.66668V10C14.6673 13.3333 13.334 14.6667 10.0007 14.6667H6.00065C2.66732 14.6667 1.33398 13.3333 1.33398 10V6.00001C1.33398 2.66668 2.66732 1.33334 6.00065 1.33334H9.33398" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6673 6.66668H12.0007C10.0007 6.66668 9.33398 6.00001 9.33398 4.00001V1.33334L14.6673 6.66668Z" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
